import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";

import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogCiiusByLevel1 = (level) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `getByLevel/${level}`);
    const body = await resp.json();

    debugLogActions(':: catalogCiiuActions, startLoadingCatalogCiiusByLevel1', { 'body': body });

    if (body.ok) {

      dispatch(loadingCatalogCiiusLevel1(body.catalogCiius));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogCiiusLevel1 = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_LEVEL1,
  payload: catalogciius,
});

export const startLoadingCatalogCiiuByParent = (idParent, level) => {
  
  return async (dispatch) => {
    
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGCIIU}`,
      `getByParentId/${idParent}`
    );
    const body = await resp.json();

    if (body.ok) {

      if (level === 2) {
        dispatch(loadingCatalogCiiusLevel2ByParent(body.catalogCiius));
      } else if (level === 3) {
        dispatch(loadingCatalogCiiusLevel3ByParent(body.catalogCiius));
      } else if (level === 4) {
        dispatch(loadingCatalogCiiusLevel4ByParent(body.catalogCiius));
      } else if (level === 5) {
        dispatch(loadingCatalogCiiusLevel5ByParent(body.catalogCiius));
      } else if (level === 6) {
        dispatch(loadingCatalogCiiusLevel6ByParent(body.catalogCiius));
      }
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogCiiuByParentLocal = (idParent, level) => {
  
  return async (dispatch, getState) => {
    const state = getState();

    const { listFullCatalogCiius } = state.catalogCiiu;

    let catalogCiius = [];
    listFullCatalogCiius.forEach((item) => {
      if (item.parent_id === idParent) {
        catalogCiius.push(item);
      }
    })

    if (level === 2) {
      dispatch(loadingCatalogCiiusLevel2ByParent(catalogCiius));
    } else if (level === 3) {
      dispatch(loadingCatalogCiiusLevel3ByParent(catalogCiius));
    } else if (level === 4) {
      dispatch(loadingCatalogCiiusLevel4ByParent(catalogCiius));
    } else if (level === 5) {
      dispatch(loadingCatalogCiiusLevel5ByParent(catalogCiius));
    } else if (level === 6) {
      dispatch(loadingCatalogCiiusLevel6ByParent(catalogCiius));
    }

  };
};

const loadingCatalogCiiusLevel2ByParent = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_LEVEL2,
  payload: catalogciius,
});

export const selectCatalogCiiuLevel1 = (catalogciiu) => ({
  type: types.CATALOGCIIU_SELECT_LEVEL1,
  payload: catalogciiu,
});

const loadingCatalogCiiusLevel3ByParent = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_LEVEL3,
  payload: catalogciius,
});

export const selectCatalogCiiuLevel2 = (catalogciiu) => ({
  type: types.CATALOGCIIU_SELECT_LEVEL2,
  payload: catalogciiu,
});

const loadingCatalogCiiusLevel4ByParent = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_LEVEL4,
  payload: catalogciius,
});

export const selectCatalogCiiuLevel3 = (catalogciiu) => ({
  type: types.CATALOGCIIU_SELECT_LEVEL3,
  payload: catalogciiu,
});

const loadingCatalogCiiusLevel5ByParent = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_LEVEL5,
  payload: catalogciius,
});

export const selectCatalogCiiuLevel4 = (catalogciiu) => ({
  type: types.CATALOGCIIU_SELECT_LEVEL4,
  payload: catalogciiu,
});

const loadingCatalogCiiusLevel6ByParent = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_LEVEL6,
  payload: catalogciius,
});

export const selectCatalogCiiuLevel5 = (catalogciiu) => ({
  type: types.CATALOGCIIU_SELECT_LEVEL5,
  payload: catalogciiu,
});

export const selectCatalogCiiuLevel6 = (catalogciiu) => ({
  type: types.CATALOGCIIU_SELECT_LEVEL6,
  payload: catalogciiu,
});

export const cleanCatalogCiiuLevel1 = () => ({
  type: types.CATALOGCIIU_CLEAN_LEVEL1,
});

export const cleanCatalogCiiuLevel2 = () => ({
  type: types.CATALOGCIIU_CLEAN_LEVEL2,
});

export const cleanCatalogCiiuLevel3 = () => ({
  type: types.CATALOGCIIU_CLEAN_LEVEL3,
});

export const cleanCatalogCiiuLevel4 = () => ({
  type: types.CATALOGCIIU_CLEAN_LEVEL4,
});

export const cleanCatalogCiiuLevel5 = () => ({
  type: types.CATALOGCIIU_CLEAN_LEVEL5,
});

export const cleanCatalogCiiuLevel6 = () => ({
  type: types.CATALOGCIIU_CLEAN_LEVEL6,
});

export const startLoadingCatalogCiiuByCode = (code) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `getByLevel/${code}`);
    const body = await resp.json();

    if (body.ok) {
      
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogCiius = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, "get");
    const body = await resp.json();

    if (body.ok) {
      
      dispatch(loadingCatalogCiius(body.catalogCiius));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogCiius = (catalogCiius) => ({
  type: types.CATALOGCIIU_START_LOADING,
  payload: catalogCiius,
});

export const startLoadingCatalogCiiusPaginatedBk = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `get/${page}/${size}`);
    const body = await resp.json();

    debugLogActions(':: catalogCiiuActions, startLoadingCatalogCiiusPaginatedBk', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogCiiusPaginated(body.catalogCiiuPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogCiiusPaginated = (page, size, currentCatalogCiiu = {}) => {
  return async (dispatch) => {

    let ciiuCode = "";
    if (currentCatalogCiiu && Object.keys(currentCatalogCiiu).length > 0) {
      ciiuCode = currentCatalogCiiu.code;
    }

    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `get/${page}/${size}/${ciiuCode}`);
    const body = await resp.json();

    debugLogActions(':: catalogCiiuActions, startLoadingCatalogCiiusPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogCiiusPaginated(body.catalogCiiuPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogCiiusPaginated = (catalogCiiuPaginated) => ({
  type: types.CATALOGCIIU_START_LOADING_PAGINATED,
  payload: catalogCiiuPaginated,
});

export const selectCatalogCiius = (catalogCiiu) => ({
  type: types.CATALOGCIIU_SELECT,
  payload: catalogCiiu,
});

export const catalogCiiuClean = () => ({
  type: types.CATALOGCIIU_CLEAN,
});

export const catalogCiiuStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGCIIU}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              if (body.ok) {
                dispatch(catalogCiiuDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogCiiuActions, catalogCiiuStartDelete', { 'error': error });
    }
  };
};

const catalogCiiuDeleted = (id) => {
  return {
    type: types.CATALOGCIIU_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogCiiusPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGCIIU}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(searchingCatalogCiiusPaginated(body.catalogCiiusPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogCiiusPaginated = (catalogCiiusPaginated) => ({
  type: types.CATALOGCIIU_START_SEARCH_PAGINATED,
  payload: catalogCiiusPaginated,
});

export const cleanSearchingCatalogCiiusPaginated = () => ({
  type: types.CATALOGCIIU_CLEAN_SEARCH_PAGINATED,
});

export const catalogCiiuStartUpdate = (catalogCiiu, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGCIIU}`,
        `update/${catalogCiiu.id}`,
        catalogCiiu,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(catalogCiiuUpdated(catalogCiiu));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-ciiu");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogCiiuActions, catalogCiiuStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogCiiu
 * @returns
 */
const catalogCiiuUpdated = (catalogCiiu) => {
  return {
    type: types.CATALOGCIIU_UPDATE,
    payload: catalogCiiu,
  };
};

export const catalogCiiuStartRegister = (catalogCiiu, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGCIIU}`,
      "add",
      catalogCiiu,
      "POST"
    );

    const body = await resp.json();

    if (body.ok) {
      dispatch(catalogCiiuRegister(body.catalogCiiu));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-ciiu");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogCiiuRegister = (catalogCiiu) => ({
  type: types.CATALOGCIIU_START_REGISTER,
  payload: catalogCiiu,
});

export const catalogCiiuSetSearchText = (searchText) => ({
  type: types.CATALOGCIIU_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogCiiuCleanSearchText = () => ({
  type: types.CATALOGCIIU_SET_SEARCH_TEXT,
});

export const startLoadingCatalogCiiusAllByLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `getByLevel/${6}`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCatalogCiiusLevel6(body.catalogciius_id));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogCiiusLevel6 = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_ALL_LEVEL6,
  payload: catalogciius,
});

export const startLoadingCatalogCiiusAll = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `get`);
    const body = await resp.json();

    debugLogActions(':: catalogCiiuActions, loadingCatalogCiiusLevel6', { 'body': body });

    if (body.ok) {
      dispatch(loadingCatalogCiiusAll(body.catalogCiius));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogCiiusAll = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_ALL,
  payload: catalogciius,
});

export const startLoadingCatalogCiiusNoLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGCIIU}`, `get`);
    const body = await resp.json();

    debugLogActions(':: catalogCiiuActions, startLoadingCatalogCiiusNoLevel6', { 'body': body });

    if (body.ok) {

      let filterCatalogCiius = body.catalogCiius.filter(ele => ele.level < 6);

      const ciiuWithoutParent = {

        id: 0,
        code: "0000",
        name: "SIN IDENTIFICACIÓN DE ID DE PADRE ",
        level: 0,
        deleted: false,
        code_visual: null,
        createdAt: "2022-10-05T05:20:20.958Z",
        updatedAt: "2022-10-05T05:20:20.958Z",
        parent_id: 9999

      }

      filterCatalogCiius.unshift(ciiuWithoutParent);

      dispatch(loadingCatalogCiiusNoLevel6(filterCatalogCiius));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogCiiusNoLevel6 = (catalogciius) => ({
  type: types.CATALOGCIIU_START_LOADING_NO_LEVEL6,
  payload: catalogciius,
});

export const loadingCatalogCiiuFilter = (catalogs) => ({
  type: types.CATALOGCIIU_START_LOADING_FILTER,
  payload: catalogs,
});